export enum Fields {
  NAME = 'name',
  FORM = 'form',
  URL = 'url',
  LABEL = 'label',
  SEGMENT = 'semgent_form',
}

export interface OwnProps {

}

export interface DispatchProps {
  setShowModal: (type: any) => void
  setHideModal: () => void
}

export interface State {
  toggleElements: any
  tableList: any
  editSegment: any
}

export type Props = any
